export const ValidaEmail = (email) => {
    if (/^[a-z0-9.]{1,64}@[a-z0-9.]{1,64}$/i.test(email)) {
        return true;
    }

    return false;
};
